<template>
  <div>
    <div class="ra-page--section">
      <el-row type="flex">
        <el-col :span="24">
          <h6>Verifications</h6>
        </el-col>

        <el-col :span="76">
          <el-button
            v-if="userCan('proxy', 'identity.bvn.simple.fetchdata')"
            type="primary"
            size="medium"
            @click="
              $router.push({ name: 'verify-identity.verifications.verify' })
            "
            >Verify New ID</el-button
          >
        </el-col>
      </el-row>
    </div>
    <el-row type="flex">
      <el-col :span="24">
        <ra-card>
          <template slot="header">
            <div class="w-100 is-flex is-align-center is-justify-between">
              <el-select
                clearable
                v-model="filters.identityType"
                class="mr-1"
                placeholder="Identity Type"
              >
                <el-option
                  v-for="(field, index) in identityTypes"
                  :key="index"
                  :label="field.short_name"
                  :value="field.id"
                ></el-option>
              </el-select>

              <el-date-picker
                class="mr-1"
                v-model="filters.startDate"
                value-format="yyyy-MM-dd"
                placeholder="Start Date"
              />

              <el-date-picker
                class="mr-1"
                v-model="filters.endDate"
                value-format="yyyy-MM-dd"
                placeholder="End Date"
              />

              <el-button
                type="success"
                :loading="loading"
                size="medium"
                :disabled="!filtersFilled"
                @click="filter"
                >Filter</el-button
              >
              <el-button
                type="danger"
                :loading="loadingClear"
                size="medium"
                :disabled="!filtersFilled"
                @click="clearFilter"
                >Clear</el-button
              >
            </div>
          </template>

          <template slot="content">
            <el-table
              :data="pageData"
              v-loading="loading"
              :empty-text="noDataMessage"
            >
              <el-table-column prop="Type of ID">
                <template slot="header">
                  <span class="ra-table--header">
                    Type of ID
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{
                      scope.row.adapterEndpoint &&
                        scope.row.adapterEndpoint.endpoint &&
                        scope.row.adapterEndpoint.endpoint.short_name
                    }}
                  </p>
                </template>
              </el-table-column>

              <el-table-column prop="ID">
                <template slot="header">
                  <span class="ra-table--header">
                    ID
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>{{ scope.row.identifier }}</p>
                </template>
              </el-table-column>

              <el-table-column prop="date">
                <template slot="header">
                  <span class="ra-table--header">
                    Date
                  </span>
                </template>
                <template slot-scope="scope">
                  <p>
                    {{ mFormatDate(scope.row.created_at, "Do MMM, YYYY") }} -
                    {{ mFormatTime(scope.row.created_at) }}
                  </p>
                </template>
              </el-table-column>

              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-dropdown class="more" @command="command">
                    <span>
                      <i class="ra-icon--more-vertical"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="ra-icon--info"
                        :command="{ action: 'show', api: scope.row }"
                      >
                        More Info</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <ra-pagination
              v-if="dataFound"
              :from="from"
              :to="to"
              :total="total"
              :pageSize="pagination.perPage"
              :current-page.sync="currentPage"
            />
          </template>
        </ra-card>
      </el-col>
    </el-row>

    <Verification
      v-if="showVerificationInfo"
      :show.sync="showVerificationInfo"
      :identityType="selectedIdentityType"
      :verification="verificationDetails"
    />
  </div>
</template>

<script>
import { dateRangeValidation } from "@/lib/utils";
import apiConstants from "@/apiConstants";
import Verification from "@/components/Products/VerifyIdentity/Verifications/Verification";
import moment from "moment";

const filter = {
  identityType: "",
  startDate: "",
  endDate: ""
};

const paging = {
  perPage: 20,
  total: 0
};

export default {
  name: "Verifications",
  components: {
    Verification
  },
  data() {
    return {
      routes: [
        {
          name: "verify-identity.index",
          label: "Verify Identity"
        },
        {
          name: "verify-identity.verifications",
          label: "Verifications"
        }
      ],
      loading: false,
      loadingClear: false,
      pageData: [],
      currentPage: 1,
      pagination: {
        ...paging
      },
      filters: { ...filter },
      noDataMessage: "No verification(s) available",
      identityTypes: [],
      verificationServiceId: apiConstants.SERVICE_IDS.VERIFICATION,
      showVerificationInfo: false,
      selectedIdentityType: "",
      verificationDetails: {},
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    },

    filtersFilled() {
      const filters = Object.values(this.filters);
      return !!filters.filter(flt => flt || flt === 0).length;
    }
  },

  methods: {
    getPaginationParams() {
      return `page_size=${this.pagination.perPage}&page=${this.currentPage}`;
    },

    resetPagination() {
      this.pagination = { ...paging };
      this.currentPage = 1;
    },

    clearFilter() {
      this.loadingClear = true;
      this.filters = { ...filter };
      this.resetPagination();
      this.loadVerifications();
    },

    filter() {
      const filters = [];
      let filtersValid = true;

      if (this.filters.identityType) {
        filters.push({
          field: "adapterEndpoint.endpoint.id",
          value: this.filters.identityType
        });
      }

      if (this.filters.startDate) {
        this.filters.startDate = moment(this.filters.startDate).format(
          "YYYY-MM-DD 00:00:00"
        );
        filters.push({
          field: "created_at",
          value: this.filters.startDate,
          cond_op: ">="
        });
      }
      if (this.filters.endDate) {
        this.filters.endDate = moment(this.filters.endDate).format(
          "YYYY-MM-DD 23:59:59"
        );
        filters.push({
          field: "created_at",
          value: this.filters.endDate,
          cond_op: "<="
        });
      }

      if (this.filters.startDate && this.filters.endDate) {
        const startAt = this.filters.startDate;
        const endAt = this.filters.endDate;
        const isValidRange = dateRangeValidation(startAt, endAt);
        if (!isValidRange) {
          this.notification(
            "Invalid Input",
            "Date range is invalid. End date must be greater than Start date",
            "danger"
          );
          filtersValid = false;
        }
      }

      if (filtersValid) {
        const params = `&filters=${JSON.stringify(filters)}`;
        this.pageData = [];
        this.loadVerifications(params);
      }
    },

    loadVerifications(customParams = "") {
      this.loading = true;
      const params = customParams;
      const apiUrl = "services/logs";

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${params}&${this.getPaginationParams()}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          this.loading = this.loadingClear = false;
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.pageData = resData.list;
            this.pagination.total = resData.pagination.total_count;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    command(command) {
      const { api } = command;
      const apiUrl = `services/logs/${api.id}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.selectedIdentityType = api.adapterEndpoint.endpoint.short_name;
            this.verificationDetails = resData.proxy_response;
            this.showVerificationInfo = Boolean(this.verificationDetails);
            if (!this.showVerificationInfo) {
              this.notification(
                "Result",
                "No verification details available",
                "warning"
              );
            }
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    },

    loadIdentityTypes() {
      const apiUrl = `services/${this.verificationServiceId}/endpoints`;
      const filters = [];
      filters.push({
        field: "status_id",
        value: apiConstants.GLOBAL_STATUS.ACTIVE
      });
      const params = `?no_pages=1&filters=${JSON.stringify(filters)}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: params
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          this.identityTypes = response.data || [];
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  },

  mounted() {
    this.loadIdentityTypes();
    this.loadVerifications();
  },

  watch: {
    currentPage() {
      this.filter();
    },

    filtersFilled(newVal, oldVal) {
      if (oldVal && !newVal && !this.dataFound) {
        this.loadVerifications();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
